<template>
  <!-- 常用联系人 -->
  <div :class="{tab:mobNavShow}">
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <van-tabs class="meeting-list-tab" v-model="activeTab" @click="changeTab">
      <van-tab v-for="name in Object.keys(tabMap)" :key="name"
               :title="tabMap[name]" :name="name">
      </van-tab>
    </van-tabs>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div v-if="refreshTime && userList.length" class="pad-top custom-steps">
        <van-cell v-for="(user, idx) in userList" :key="idx" title-class="mar-top-5">
          <template #title>
            <div v-if="user.userId" class="pull-right user-cell-value">
              <p class="text-sm text-right">{{user.position}}</p>
              <p class="text-sm text-right">{{user.deptNames && user.deptNames[0] || ""}}</p>
            </div>
            <div>
              <span class="color-box mar-rgt-10"
                    :style="`background-color:rgba(${user.headerColor},0.35)`">{{user.name[0]}}</span>
              <span class="custom-title">{{user.name}}</span>
              <span v-if="!user.userId" class="custom-title"> - {{user.tel}}</span>
            </div>
          </template>
        </van-cell>

        <!--<van-swipe-cell>
          <template #right>
          </template>
        </van-swipe-cell>-->
      </div>

      <div v-else>
        <empty-notice :desc="'暂无内容'"></empty-notice>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  import {account} from "../../../../server";
  import {refreshDebounce, checkShowPermit} from "../../../../tools/utils";

  export default {
    data() {
      return {
        activeTab: "inner",
        refreshing: false,
        refreshTime: "",
        userList: [],
        isInner: true
      }
    },
    computed: {
      outsideParticipantTitle() {
        return this.$store.state.formTitles.outsideParticipant
      },
      tabMap() {
        return {
          inner: "内部联系人",
          outer: this.outsideParticipantTitle
        }
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    mounted() {
      this.getUserList()
    },
    methods: {
      // 切换内部、外部参会人
      changeTab(name) {
        // console.log(name);
        this.isInner = name === 'inner';
        this.getUserList()
      },
      onRefresh() {
        // 刷新防抖动
        if (this.refreshing && this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.getUserList()
      },
      // 获取查询参会人
      getUserList() {
        // 初次加载时显示加载圈
        if (!this.refreshing && !this.refreshTime) {
          UILoader.load()
        }
        account.frequentUser(this, {inner: this.isInner}).then(({searchFrequentUserList: data = {}}) => {
          UILoader.unload();
          this.refreshTime = new Date();
          this.userList = (data.userEdges || []).map(e => ({...e.user}));
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        })
      },
    }
  }
</script>

<style lang="less">
  .user-cell-value {
    margin-top: -6px;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .tab {
    .meeting-list-tab .van-tabs__wrap {
      margin-top: 46px !important;
    }

    .pad-top {
      // padding-top: 58px !important;
    }
  }
</style>
